<template>
  <div class="container">
    <div class="title">
      <div class="title-center">{{ formDate.name }}</div>
      <div class="equipment">
        <img src="../assets/img/start-top.png" alt="">
        <span>{{ formDate.state === 1 ? 'Run' : formDate.state === 0 ? 'Stare Up' : 'Stop' }}</span>
      </div>
      <div class="time">
        <img src="../assets/img/time-top.png" alt="">
        <span>{{ nowDateList }}&nbsp;&nbsp;&nbsp; {{ nowDate }}</span>
<!--   {{ nowDateWeek }}     -->
      </div>
    </div>

    <div class="content-box" >
      <div class="left">
        <div class="title">Printing Speed (sheets/hour)</div>
        <div class="value">{{ formDate.speed ? formDate.speed : '--'}}</div>
      </div>
      <div class="right">
        <div class="right-top">
          <div class="right-item">
            <img src="@/assets/img/icon-c.png" alt="">
            <span>Conductivity:</span>
            <span class="value">{{ formDate.ddl ? formDate.ddl : '--' }}</span>
          </div>
          <div class="right-item">
            <img src="@/assets/img/icon-ph.png" alt="">
            <span class="ph">PH Value:</span>
            <span class="value">{{ formDate.ph ? formDate.ph : '--' }}</span>
          </div>
          <div class="right-item">
            <img src="@/assets/img/icon-t.png" alt="">
            <span>Temperature:</span>
            <span class="value">{{ formDate.wd ? formDate.wd : '--'}}</span>
          </div>
        </div>
        <div class="right-top">
          <div class="right-item">
            <img src="@/assets/img/icon-number.png" alt="">
            <span>Total Sheets:</span>
            <span class="value">{{ formDate.printCount }}</span>
          </div>
          <div class="right-item">
            <img src="@/assets/img/icon-item.png" alt="">
            <span>Prodn.Hours:</span>
            <span class="value">{{ formDate.time }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";

export default {
name: "dataMonitorEquipment.vue",
  data() {
    return {
      nowDate:'',
      nowDateList: '',
      nowDateWeek: '',
      //deviceId
      formDate: {
        conductivity: 0,
        ph: 0,
        temperature: 0,
        ddl: '',
        wd: '',
        speed: '',
        printCount: '',
        time:'',
        chanNengOee: '',
        timeOee: '',
        name:'',
        state:0
      }
    }
  },
  created() {
    this.currentTime()
    this.getFormDate()
    this.currentTime2()
  },
  methods: {
    getDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let hour = date.getHours(); // 时
      let week = date.getDay(); // 星期
      let weekArr = [ "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六" ];
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = `${hour}:${minute}:${second}`;
      this.nowDateList = `${year}.${month}.${day}`;
      // if (cookies.get('teamId') === '128812f8-354f-470f-b8fa-c33ff62b51d1') {
      //   this.formDate.date = this.nowDateList
      //   // this.getValue()
      // }
      this.nowDateWeek = `${weekArr[week]}`
    },
    getFormDate() {
      API.getDaPingJiTaiyinDu({deviceId: this.$route.query.deviceId}).then(res => {
        console.log(res)
        if (res.message.success) {
          this.formDate = res.message.data
        }
        console.log(this.formDate)
      })
    },
    currentTime(){
      setInterval(()=>{
        this.getDate()
      },1000)
    },
    currentTime2(){
      setInterval(()=>{
        this.getFormDate()
      },10000)
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  background: linear-gradient(180deg, #E9EFF5 0%, #E4EEFA 100%);
  width: 100%;
  height: 100vh;
  overflow-y: auto;
}
.title {
  width: 100%;
  font-size: 55px;
  font-weight: bold;
  text-align: center;
  position: relative;
  //border-bottom: 1px solid #dcdddd;
  color: #222222;
  //background: -webkit-linear-gradient(#3268A6,#152E66);
  ////-webkit-background-clip: text;
  //-webkit-text-fill-color: transparent;
  line-height: 90px;
  background-image: url("~@/assets/img/monitor.png");
  background-size: 100% 100%;
  //background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .title-center{
    background: -webkit-linear-gradient(#3268A6,#152E66);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.equipment {
  position: absolute;
  color: #222222;
  font-size: 32px;
  top: -15px;
  left: 50px;
  display: flex;
  font-weight: normal;
  align-items: center;
  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
}
.time {
  position: absolute;
  color: #222222;
  font-size: 32px;
  top: -15px;
  right: 15px;
  display: flex;
  font-weight: normal;
  align-items: center;
  img{
    width: 24px ;
    height: 24px;
    margin-right: 10px;
  }
}
.content-box {
  padding: 25px 30px 55px;
  display: flex;
  justify-content: space-between;
  gap: 30px;
}
.left {
  padding: 40px 60px;
  background: linear-gradient(180deg, #C6DEFF 0%, #F2F7FE 100%);
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  border: 1.5px solid #FFFFFF;
  width: 63%;
  .title {
    font-size: 50px;
    color: #222222;
    background-image:none;
    text-align: left;
    font-weight: normal;
  }
  .value {
    font-size: 362px;
    color: #146BF8;
    font-weight: bold;
    padding: 130px 0;
    text-align: center;
  }
}
.right {
  font-size: 52px;
  color: #222222;
}
.right-top {
  padding: 60px 50px;
  background: linear-gradient(180deg, #D7E8FF 0%, #F0F5FB 100%);
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  border: 1.5px solid #FFFFFF;
  gap: 30px;
  display: grid;
  margin-bottom: 30px;
  height: 48.3%;
  img{
    width: 45px;
    margin-right: 30px;
  }
  .right-item {
    display: flex;
    align-items: center;
    .ph{
      width: 300px;
      display: inline-block;
    }
    .value {
      width: 250px;
      text-align: right;
      color: #146BF8;
    }
  }
}
.right-top:last-child{
  margin-bottom: 0;
}
</style>
